import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Slide,
} from '@mui/material';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import Iconify from '../common/iconify.component';
import Loading from '../table-elements/loading.component';
import { CONTENT_ALIAS } from '../../config/const.config';

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const ListSequenceShows = ({
  handleOnDragEndShows,
  handleUpdateShowsSequence,
  action,
  selectedCategory,
  categoryShowsList,
  showOptions,
  handleCloseDialog,
}) => (
  <Dialog
    open={action.show}
    onClose={() => handleCloseDialog()}
    aria-describedby="channel-category-shows"
    aria-labelledby="channel-category-shows"
    TransitionComponent={Transition}
    fullWidth
    maxWidth="md"
  >
    <DialogTitle>{`Reorder ${CONTENT_ALIAS.SHOW_PLURAL} Sequence - ${selectedCategory.categoryName}`}</DialogTitle>

    <DialogContent dividers>
      {showOptions.loading && <Loading />}

      {!showOptions.loading && (
        <DragDropContext onDragEnd={handleOnDragEndShows}>
          <Droppable droppableId="shows">
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {!showOptions.loading &&
                  categoryShowsList.length > 0 &&
                  categoryShowsList.map((show, index) => (
                    <Draggable
                      key={`show-${show.id}`}
                      draggableId={show.id.toString()}
                      index={index}
                    >
                      {(provide) => (
                        <Card
                          sx={{
                            marginBottom: '5px',
                          }}
                          ref={provide.innerRef}
                          {...provide.draggableProps}
                          {...provide.dragHandleProps}
                        >
                          <CardContent
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              paddingY: '12px',
                              '&:last-child': {
                                paddingBottom: '12px',
                              },
                            }}
                          >
                            <div>{`${show.name} (${show.totalEpisodes} ${
                              show.totalEpisodes > 1 ? 'Episodes' : 'Episode'
                            })`}</div>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  marginLeft: 10,
                                }}
                              >
                                <Iconify icon="ic:round-table-rows" />
                              </div>
                            </div>
                          </CardContent>
                        </Card>
                      )}
                    </Draggable>
                  ))}

                {!showOptions.loading && categoryShowsList.length === 0 && (
                  <Paper
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    No data available.
                  </Paper>
                )}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}
    </DialogContent>

    <DialogActions>
      <Button
        onClick={handleUpdateShowsSequence}
        disabled={
          categoryShowsList.length === 0 || categoryShowsList.length === 1
        }
      >
        Save
      </Button>
      <Button onClick={handleCloseDialog}>Cancel</Button>
    </DialogActions>
  </Dialog>
);

ListSequenceShows.propTypes = {
  handleOnDragEndShows: PropTypes.func.isRequired,
  handleUpdateShowsSequence: PropTypes.func.isRequired,
  action: PropTypes.object.isRequired,
  selectedCategory: PropTypes.object.isRequired,
  categoryShowsList: PropTypes.array.isRequired,
  showOptions: PropTypes.object.isRequired,
  handleCloseDialog: PropTypes.func.isRequired,
};

export default ListSequenceShows;
